import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import { dataFetch, DIGGER_API_SUFFIX } from '../../../axios/customAxios'
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';
import {CORE_API_SUFFIX} from "../../../axios/customAxios";

const useGetSnapchatOrganizations = (
    identifier: string,
) => useQuery<AxiosResponse, ApiError<null>, any>(
    [`${identifier}`],
    () => dataFetch.get(`${CORE_API_SUFFIX}snapchat/organizations-with-ad-accounts`),
);

export default useGetSnapchatOrganizations;
